import { createSafetyStorages } from '@mail-core/std/storage';
import { xray } from 'lib/xray';
import { USER_EMAIL } from 'reactApp/appHelpers/configHelpers';

export const [safetyPersonalLocalStorage, safetyPersonalSessionStorage, safetyPersonalRuntimeStorage] = createSafetyStorages({
    disabled: false,
    keyPattern: (key) => `${USER_EMAIL || ''}|${key}`,
    // eslint-disable-next-line max-params
    onerror: (storage, method, error, key, value) => {
        xray.send(`stg-${storage}-${method}`, {
            rlog: 'cloud_app_storage_err',
            rlog_message: {
                storage,
                method,
                key,
                value,
                error,
            },
        });
    },
});

export interface StorageData {
    shows?: string[];
    isComplete?: boolean;
    state?: boolean;
    time?: number;
    counts?: { show?: number; close?: number };
}

// Возвращает данные о показах баннера
export const getBannerDataFromStorage = (promoID: string): StorageData => {
    try {
        return JSON.parse(safetyPersonalLocalStorage.getItem(promoID) || '{}');
    } catch {
        return {};
    }
};

export const updateBannerDataFromStorage = (promoID: string, data: StorageData) => {
    safetyPersonalLocalStorage.setItem(promoID, JSON.stringify(data));
};

// Помечает баннер completed
export const markBannerCompleted = (promoID: string) => {
    updateBannerDataFromStorage(promoID, {
        ...getBannerDataFromStorage(promoID),
        state: true,
    });
};

export const getDataFromStorage = <T = StorageData>(keyId: string): Partial<T> => {
    try {
        return JSON.parse(safetyPersonalLocalStorage.getItem(keyId) || '{}') as Partial<T>;
    } catch {
        return {} as Partial<T>;
    }
};

export const saveDataToStorage = <T = StorageData>(keyId: string, data: Partial<T>) => {
    try {
        const prevData = getDataFromStorage<T>(keyId);
        safetyPersonalLocalStorage.setItem(keyId, JSON.stringify({ ...prevData, ...data }));
    } catch {}
};
